<app-login *ngIf="currentScreen=='login'" ></app-login>
<app-display *ngIf="currentScreen=='display'"></app-display>
<app-raport-vanzari *ngIf="currentScreen=='raport-vanzari'"></app-raport-vanzari>
